import { Breadcrumb, Tab, Tabs } from "react-bootstrap";

import OralHealthCourseTable from "components/Admin/OralHealthCourseTable";

const AdminEducationOralHealthPage = () => (
  <>
    <Breadcrumb>
      <Breadcrumb.Item>구강보건교육</Breadcrumb.Item>
    </Breadcrumb>

    <Tabs defaultActiveKey="home">
      <Tab eventKey="home" title="온라인 교육">
        <OralHealthCourseTable />

      </Tab>
      {/* <Tab eventKey="notice" title="공지사항">
        <CourseNoticeTable />
      </Tab> */}
    </Tabs>
  </>
);
export default AdminEducationOralHealthPage;
